import React, { useEffect, useRef, useState } from "react";
import MonthYearPicker from "../../../components/common/ui/Inputs/MonthYearPicker";
import Button from "../../../components/common/ui/Button";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";
import Table from "../../../components/common/table/Table";
import MultiSelectDropdown from "../../../components/common/ui/Inputs/MultiSelectDropdown";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { masterActions } from "../../../_store/master.slice";
import { reportActions } from "../../../_store/reports.slice";
import { exportExcel } from "../../../utils/exportExcel";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import CommitteeLoginReport from "../../../components/common/export/LoginReportPDF";
import CustomLoader from "../../../components/common/ui/Loader";

function LoginReport() {
  const dispatch = useDispatch();
  const ignoreSelectChange = useRef(false);

  const { loginReportList, loading: reportLoading } = useSelector(
    (state) => state.report,
  );

  const [excelBtnDisabled, setExcelBtnDisabled] = useState(false);
  const [pdfBtnDisabled, setpdfBtnDisabled] = useState(false);
  const { getCommitteeListResponse, loading } = useSelector(
    (state) => state.master,
  );
  const [filters, setFilters] = useState({
    fromDate: format(new Date(2014, 0), "yyyy-MM"),
    toDate: format(new Date(), "yyyy-MM"), // current month
    committees: [],
    isExport: false,
  });
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);
  const [apiParams, setApiParams] = useState(`?page=${1}&limit=${10}`);

  useEffect(() => {
    dispatch(masterActions?.getCommitteeList());
  }, [dispatch]);

  const columns = [
    {
      name: "Month & Year",
      key: "monthName",
      selector: (row) => row?.monthName,
      sortable: true,
    },
    {
      name: "Committee Name",
      key: "committeeName",
      selector: (row) => row?.committeeName,
      sortable: true,
    },
    {
      name: "Committee Members Count",
      key: "totalMemberCount",
      selector: (row) => row?.totalMemberCount,
      sortable: true,
    },

    {
      name: "#Logged-In Count",
      key: "loginHistory",
      selector: (row) => row?.loginHistory,
      sortable: true,
    },
    {
      name: "%Logged-In Count",
      key: "loginPercentage",
      selector: (row) => row.loginPercentage + "%",
      sortable: true,
    },
  ];

  const handleDateChange = (name, value) => {
    let updated = { ...filters, [name]: value };
    if (updated.fromDate && updated.toDate) {
      const from = new Date(updated.fromDate + "-01");
      const to = new Date(updated.toDate + "-01");
      if (from > to) {
        if (name === "fromDate") updated.toDate = updated.fromDate;
        else updated.fromDate = updated.toDate;
      }
    }
    setFilters(updated);
  };

  // const handleRowPerPage = (page) => {
  //   ignoreSelectChange.current = true;
  //   const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
  //   setApiParams(updatedParams);
  //   dispatch(
  //     reportActions.getLoginReport({
  //       params: updatedParams,
  //       payload: filters,
  //     })
  //   )
  //     .then((result) => {
  //       if (result?.payload?.data) {
  //         ignoreSelectChange.current = false;
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err?.message);
  //     });
  //   setRowCountPerPage(page);
  //   setPageNo(1);
  // };

  const handleRowPerPage = (pageSize) => {
    ignoreSelectChange.current = true;

    const params = `?page=1&limit=${pageSize}`;

    setApiParams(params);
    setPageNo(1);
    setRowCountPerPage(pageSize);

    dispatch(
      reportActions.getLoginReport({
        params,
        payload: filters,
      }),
    )
      .then((result) => {
        if (result?.payload?.data) {
          ignoreSelectChange.current = false;
        }
      })
      .catch((err) => {
        console.log(err?.message);
      });
  };

  const handlePageChange = (page) => {
    ignoreSelectChange.current = true;
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    dispatch(
      reportActions.getLoginReport({
        params: updatedParams,
        payload: filters,
      }),
    )
      .then((result) => {
        if (result?.payload?.data) {
          ignoreSelectChange.current = false;
        }
      })
      .catch((err) => {
        console.log(err?.message);
      });
    setPageNo(page);
  };

  const handleSelectChange = (selectedOptions, fieldName) => {
    if (ignoreSelectChange.current) return;
    const selectedIds = selectedOptions?.map((item) => item.value) || [];
    // setSelectedCommitteeList(selectedIds);
    setFilters((prevForm) => ({
      ...prevForm,
      [fieldName]: selectedIds,
    }));
  };

  const handleExcelExport = () => {
    ignoreSelectChange.current = true;
    setExcelBtnDisabled(true);
    const updateParams = { ...filters, isExport: true };
    setFilters(updateParams);
    dispatch(
      reportActions.getLoginReport({
        params: apiParams,
        payload: updateParams,
      }),
    )
      .then((res) => {
        const updateParams = { ...filters, isExport: false };
        setFilters(updateParams);
        if (res?.payload?.data) {
          ignoreSelectChange.current = false;
        }
        setExcelBtnDisabled(false);
        const formattedData = res?.payload?.data?.results?.map((item) => ({
          "Month & Year": item.monthName,
          "Committee Name": item.committeeName,
          "Committee Members Count": item.totalMemberCount,
          "#Logged-In Count": item.loginHistory,
          "%Logged-In Count": item.loginPercentage,
        }));
        const now = new Date();

        const formattedDate =
          now.getFullYear() +
          "" +
          String(now.getMonth() + 1).padStart(2, "0") +
          "" +
          String(now.getDate()).padStart(2, "0");

        const formattedTime =
          String(now.getHours()).padStart(2, "0") +
          "" +
          String(now.getMinutes()).padStart(2, "0") +
          "" +
          String(now.getSeconds()).padStart(2, "0");

        const safeTitle = "Login-report".replace(/[^a-z0-9]/gi, "_");
        const fileName = `${safeTitle}_${formattedDate}_${formattedTime}.xlsx`;
        exportExcel(formattedData, fileName, "Login report status");
      })
      .catch((err) => {
        setExcelBtnDisabled(false);
        showToastNotification("Failed to export data", "error");
      });
  };

  const handlePDFExport = () => {
    ignoreSelectChange.current = true;
    let title = "Login Report";
    setpdfBtnDisabled(true);
    const updateParams = { ...filters, isExport: true };
    setFilters(updateParams);
    dispatch(
      reportActions.getLoginReport({
        params: apiParams,
        payload: updateParams,
      }),
    )
      .then((res) => {
        const updateParams = { ...filters, isExport: false };
        setFilters(updateParams);
        if (res?.payload?.data) {
          ignoreSelectChange.current = false;
        }
        setpdfBtnDisabled(false);
        const formattedData = res?.payload?.data?.results?.map((item) => ({
          monthYear: item?.monthName,
          committeeName: item?.committeeName,
          totalMemberCount: item?.totalMemberCount,
          loginHistory: item?.loginHistory,
          loginPercentage: item?.loginPercentage,
        }));
        CommitteeLoginReport(formattedData, false, title);
      })
      .catch((err) => {
        console.log(err?.message);
        setpdfBtnDisabled(false);
        showToastNotification("Failed to export data", "error");
      });
  };

  const handleSearch = (e) => {
    e?.preventDefault();
    ignoreSelectChange.current = true;

    dispatch(
      reportActions.getLoginReport({ params: apiParams, payload: filters }),
    )
      .then((result) => {
        if (result?.payload?.data) {
          ignoreSelectChange.current = false;
        }
      })
      .catch((err) => {
        console.log(err?.message);
      });
  };

  // const handleReset = (e) => {
  //   e?.preventDefault();
  //   dispatch(reportActions?.resetLoginReport());
  //   setFilters({ ...filters, committees: [] });
  // };

  const handleReset = (e) => {
    e?.preventDefault();
    dispatch(reportActions?.resetLoginReport());
    setApiParams(`?page=${1}&limit=${10}`);
    setPageNo(1);
    setRowCountPerPage(10);
    setFilters({
      ...filters,
      fromDate: format(new Date(2014, 0), "yyyy-MM"),
      toDate: format(new Date(), "yyyy-MM"),
      committees: [],
      isExport: false,
    });
  };

  const toLocalMonthStart = (yyyyMm) => {
    const [year, month] = yyyyMm.split("-").map(Number);
    return new Date(year, month - 1, 1);
  };

  if (reportLoading || loading) return <CustomLoader />;
  return (
    <div className="flex justify-end mb-1 p-4">
      <h1 className="header-color">Login Report</h1>
      <form className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100 p-3">
        <div className="row">
          <div className="col-md-4">
            <MonthYearPicker
              name="fromDate"
              label="From Date"
              value={filters.fromDate}
              handleChange={(val) => handleDateChange("fromDate", val)}
              minDate={new Date("2014-01-01")}
              // maxDate={new Date(filters.toDate + "-01")}
              maxDate={toLocalMonthStart(filters.toDate)}
            />
          </div>

          <div className="col-md-4">
            <MonthYearPicker
              name="toDate"
              label="To Date"
              value={filters.toDate}
              handleChange={(val) => handleDateChange("toDate", val)}
              // minDate={new Date(filters.fromDate + "-01")}
              minDate={toLocalMonthStart(filters.fromDate)}
              // maxDate={new Date("2030-11-01")}
              maxDate={new Date()}
            />
          </div>

          <div className="col-md-4">
            <MultiSelectDropdown
              name="committees"
              options={getCommitteeListResponse?.data}
              displayValue="label"
              handleChange={(e) => handleSelectChange(e, "committees")}
              placeholder="Choose Committee"
              required
              label="Committee"
              sortType="alphabetical"
              selectedValue={
                Array.isArray(getCommitteeListResponse?.data) &&
                Array.isArray(filters?.committees)
                  ? getCommitteeListResponse.data.filter((option) =>
                      filters.committees.includes(option.value),
                    )
                  : []
              }
            />
          </div>
        </div>
        <div className="row mt-3 d-flex justify-content-center">
          <div className="col-md-2 d-flex align-items-end h-100 mt-2 mt-lg-0 gap-2">
            <Button
              status="secondary"
              label="Search"
              type="button"
              onClick={(e) => {
                handleSearch(e);
              }}
              disabled={filters?.committees?.length === 0}
            />
            <Button
              status="reset"
              label="Reset"
              type="reset"
              disabled={filters?.committees?.length === 0}
              onClick={(e) => {
                handleReset(e);
              }}
            />
          </div>
        </div>
      </form>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <div className="d-flex justify-content-between align-items-center p-3">
          <h1 className="m-0 search-header-color">Login Report List</h1>
          {loginReportList?.data?.results?.length > 0 && (
            <div className="d-flex gap-3">
              <button
                className="btn btn-success btn-sm d-flex align-items-center gap-1"
                onClick={() => {
                  handleExcelExport();
                }}
                disabled={excelBtnDisabled}
              >
                <FaFileExcel size={14} />
                <span>Export to Excel</span>
              </button>
              <button
                className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                onClick={() => {
                  handlePDFExport();
                }}
                disabled={pdfBtnDisabled}
              >
                <FaFilePdf size={14} />
                <span>Export to PDF</span>
              </button>
            </div>
          )}
        </div>

        <Table
          columns={columns}
          data={loginReportList?.data?.results}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={loginReportList?.data?.totalItems}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>
    </div>
  );
}

export default LoginReport;
